import { useEffect, useState } from "react";

import { userService } from "../../services/api";

import styles from "./Users.module.css";
import toShort from "../../utils/dateParser";

import Loading from "../../components/Loading";

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await userService.getAllUsers();
        setUsers(response.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  if (loading) return <Loading loadingText="Loading users..." />;

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr>
            <th>User Id</th>
            <th>Username</th>
            <th>Email</th>
            <th>Role</th>
            <th>Active</th>
            <th>Created At</th>
            <th>Updated At</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="13" className={styles.noData}>
                No users found.
              </td>
            </tr>
          ) : (
            users.map((user) => (
              <tr key={user.id} className={styles.tableRow}>
                <td className={styles.userId}>{user.id}</td>
                <td className={styles.username}>{user.username}</td>
                <td className={styles.normal}>{user.email}</td>
                <td className={styles.normal}>{user.role}</td>
                <td className={styles.normal}>{user.isActive ? "Yes" : "No"}</td>
                <td className={styles.date}>{toShort(user.createdAt)}</td>
                <td className={styles.date}>{toShort(user.updatedAt)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className={styles.tableFooter}></div>
    </div>
  );
}

export default Users;
